import { render, staticRenderFns } from "./locale.vue?vue&type=template&id=130e7ba7&"
import script from "./locale.vue?vue&type=script&lang=js&"
export * from "./locale.vue?vue&type=script&lang=js&"
import style0 from "./locale.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/locale.vue
// module id = 677
// module chunks = 0